// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Split the screen in half */
.splitl {
  padding: 0 2rem;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: #07070e;
  text-align: center;
}

.text-truncate{
  width: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-truncate:hover{
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mainBackButton{
  background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    padding: 7px 9px 5px 7px;
}

.mainBackButton-windowing {
  background-color: transparent;
    border: none;
    cursor: pointer;
    position: fixed;
    top: 4px;
    border-radius: 20px;
    left: 4px;
    padding: 7px 9px 5px 7px;
}

.iframeRoot .mainBackButton{
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  border-radius: 20px;
  left: 2px;
  padding: 7px 9px 5px 7px;
}

.unauthorized .started {
  text-align: center;
  font-size: 40px;
}

.split {
  height: 100%;
  width: 100%;
  width: -webkit-fill-available;
  overflow-x: hidden;
}

.left > div {
  height: 83%;
}

/* Control the right side */
.right {
  right: 0;
  background-color: #07070e;
}

/* If you want the content centered horizontally and vertically */
.centered {
  position: absolute;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* Style the image inside the centered container, if needed */
.mainContainer {
  padding: 3rem 2rem 3rem 0;
  width: 100%;
  height: 100%;
  height: -webkit-fill-available;
  height: -moz-available;
  min-height: 500px;
}

.iframeRoot .mainContainer {
  padding: 0rem 2rem 3rem 3rem;
  width: auto;
  min-height: 500px;
  /* max-height: 87vh; */
}

.started > * {
    margin: 0;
    /* padding-bottom:2rem; */
}

.help-drag {
  display: none;
}

.react-split__sash:hover ~ .react-split__pane > .help-drag {
  width: 100%;
  height: 100%;
  position: absolute;
  display: block;
}

.totalBodyOfApplication {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100%;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}

/* Control the left side */
.left {
  align-items: center;
}

.left > div {
  height: 83%;
}

/* Control the right side */
.right {
  right: 0;
  background-color: #07070e;
}

/* If you want the content centered horizontally and vertically */
.centered {
  position: absolute;
  transform: translate(-50%, -50%);
  text-align: center;
}


.totalBodyOfApplication {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100%;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  border: 1px solid #999999 !important;
  background: #919191 !important;
  color: #666666 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashBoardLayout/DashboardLayout.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,6BAA6B;IAC3B,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;EACE,6BAA6B;IAC3B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B","sourcesContent":["/* Split the screen in half */\n.splitl {\n  padding: 0 2rem;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: #07070e;\n  text-align: center;\n}\n\n.text-truncate{\n  width: inherit;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-truncate:hover{\n  white-space: wrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mainBackButton{\n  background-color: transparent;\n    border: none;\n    cursor: pointer;\n    border-radius: 20px;\n    padding: 7px 9px 5px 7px;\n}\n\n.mainBackButton-windowing {\n  background-color: transparent;\n    border: none;\n    cursor: pointer;\n    position: fixed;\n    top: 4px;\n    border-radius: 20px;\n    left: 4px;\n    padding: 7px 9px 5px 7px;\n}\n\n.iframeRoot .mainBackButton{\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  top: 20px;\n  border-radius: 20px;\n  left: 2px;\n  padding: 7px 9px 5px 7px;\n}\n\n.unauthorized .started {\n  text-align: center;\n  font-size: 40px;\n}\n\n.split {\n  height: 100%;\n  width: 100%;\n  width: -webkit-fill-available;\n  overflow-x: hidden;\n}\n\n.left > div {\n  height: 83%;\n}\n\n/* Control the right side */\n.right {\n  right: 0;\n  background-color: #07070e;\n}\n\n/* If you want the content centered horizontally and vertically */\n.centered {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n/* Style the image inside the centered container, if needed */\n.mainContainer {\n  padding: 3rem 2rem 3rem 0;\n  width: 100%;\n  height: 100%;\n  height: -webkit-fill-available;\n  height: -moz-available;\n  min-height: 500px;\n}\n\n.iframeRoot .mainContainer {\n  padding: 0rem 2rem 3rem 3rem;\n  width: auto;\n  min-height: 500px;\n  /* max-height: 87vh; */\n}\n\n.started > * {\n    margin: 0;\n    /* padding-bottom:2rem; */\n}\n\n.help-drag {\n  display: none;\n}\n\n.react-split__sash:hover ~ .react-split__pane > .help-drag {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: block;\n}\n\n.totalBodyOfApplication {\n  display: flex;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n\n/* Control the left side */\n.left {\n  align-items: center;\n}\n\n.left > div {\n  height: 83%;\n}\n\n/* Control the right side */\n.right {\n  right: 0;\n  background-color: #07070e;\n}\n\n/* If you want the content centered horizontally and vertically */\n.centered {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n\n.totalBodyOfApplication {\n  display: flex;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  border: 1px solid #999999 !important;\n  background: #919191 !important;\n  color: #666666 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
